<template>
    <div class="dnl:h-full dnl:flex dnl:flex-col">
        <slot></slot>
    </div>
</template>